<template>
  <button
    class="btn -material -ico-only -no-container help"
    :class="classes"
    :aria-label="title"
    :title="title"
    @click="start"
  >
    <i class="material-symbols-outlined" aria-hidden="true">{{ icon }}</i>
  </button>
</template>

<script>
import { mapActions } from 'pinia'
import { useToursStore } from '@/stores/tours'

export default {
  name: 'TourButton',
  props: {
    icon: {
      type: String,
      default: 'info',
    },
    classes: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    guidedTourId: {
      type: String,
      default: '',
    },
    tourId: {
      type: String,
      default: '',
    },
  },

  methods: {
    ...mapActions(useToursStore, ['startGuidedTour']),

    start() {
      this.startGuidedTour({
        guidedTourId: this.guidedTourId,
        tourId: this.tourId,
        force: true,
      })
    },
  },
}
</script>
